<input
  #attachPhotoInput
  sbS3MediaUpload
  [maxCount]="10"
  [uploadType]="'message_album_photo'"
  (uploadInit)="
    conversationStore.attemptToUploadPhotos(
      $event,
      conversationStore.conversation()!,
      messagePhotoAlbumConfig.messageForm
    )
  "
/>

<div class="text-align-center height-full display-flex flex-direction-column">
  <sb-scrollbox class="flex-grow-1" [boundaryEffect]="true">
    <div class="ph-6 pb-6 pt-12">
      <h1 class="t-5@r color-void">Your Message Album</h1>

      @if (messagePhotoAlbumStore.initialized()) {
        @if (messagePhotoAlbumStore.pendingPhotos().length) {
          <sb-nav class="mh-auto mt-4" [type]="'pill'">
            <button
              sbNavLink
              [active]="messagePhotoAlbumStore.activeSectionName() === 'approved'"
              (click)="messagePhotoAlbumStore.open('approved')"
            >
              Approved
            </button>

            <button
              sbNavLink
              [active]="messagePhotoAlbumStore.activeSectionName() === 'pending'"
              (click)="messagePhotoAlbumStore.open('pending')"
            >
              Pending
            </button>
          </sb-nav>
        }

        @switch (messagePhotoAlbumStore.activeSectionName()) {
          @case ('pending') {
            <div class="media-grid mt-6">
              @for (photo of messagePhotoAlbumStore.pendingPhotos(); track photo.id) {
                <sb-media-tile [blurred]="true" [clickable]="false" [item]="photo">
                  <div class="pending-indicator border-radius-circle position-relative" top-right>
                    <sb-icon class="color-white i-9@r display-block center-absolute" [name]="'time'" />
                  </div>
                </sb-media-tile>
              }
            </div>

            <ng-container *ngTemplateOutlet="loadMoreBtn" />

            <p class="t-9@r color-iron mt-4">
              Once approved, your photos will automatically be delivered to members you had sent them to. <br /><br />
              In the future, you can instantly send approved photos to any member you’d like.
            </p>
          }

          @case ('approved') {
            @if (messagePhotoAlbumStore.error(); as error) {
              <div class="form-error mt-4 pf-4 color-red text-align-left">
                <div class="display-flex">
                  <p class="mb-0 font-weight-500 flex-grow-1 mr-1">
                    {{ error.count | pluralize: 'Photo' }} not added to album
                  </p>
                  <sb-icon
                    class="cursor-pointer"
                    [name]="'simple-remove'"
                    [size]="'6'"
                    (click)="messagePhotoAlbumStore.clearError()"
                  />
                </div>
                @for (message of error.messages; track $index) {
                  <p class="mb-0">{{ message }}</p>
                }
              </div>
            }

            @if (messagePhotoAlbumStore.approvedPhotos().length) {
              <div class="display-flex align-items-center mv-4">
                <p
                  class="t-10@r color-ash mb-0 flex-grow-1 text-align-left text-transform-uppercase letter-spacing-0.06"
                >
                  @if (messagePhotoAlbumStore.editing() === false) {
                    Select up to 10 photos to send
                  } @else {
                    Select photos to edit
                  }
                </p>

                @if (!messagePhotoAlbumStore.editing()) {
                  <sb-context-menu class="t-5@r context-menu">
                    <li>
                      <a (click)="messagePhotoAlbumStore.startEditing()">Edit</a>
                    </li>
                  </sb-context-menu>
                }
              </div>

              <div class="media-grid">
                <sb-media-placeholder class="t-3@r" [isMessagePhoto]="true" (click)="attachPhotoInput.click()" />

                @for (photo of messagePhotoAlbumStore.approvedPhotos(); track photo.id) {
                  <sb-media-tile
                    [border]="photo.selected ? (messagePhotoAlbumStore.editing() ? 'red' : 'blue') : undefined"
                    [item]="photo"
                    [semiTransparent]="photo.selected"
                    (bgClick)="messagePhotoAlbumStore.togglePhotoSelection(photo.id)"
                  >
                    @if (photo.selected) {
                      <div
                        bottom-right
                        class="approved-indicator border-radius-circle position-relative border-2 border-color-white"
                        [ngClass]="messagePhotoAlbumStore.editing() ? 'bg-red' : 'bg-blue'"
                      >
                        <sb-icon class="color-white i-8@r center-absolute" [name]="'check'" />
                      </div>
                    }
                  </sb-media-tile>
                }
              </div>

              <ng-container *ngTemplateOutlet="loadMoreBtn" />
            } @else {
              <sb-media-placeholder
                class="t-1@r mt-6 mh-auto empty-grid"
                [isMessagePhoto]="true"
                (click)="attachPhotoInput.click()"
              />

              <p class="t-7@r mt-6 mb-0 font-weight-500 color-void">Send Photos in Messages</p>
              <p class="t-9@r color-iron mt-2">
                Upload photos to your album.<br />
                Once approved, send them in any conversation.
              </p>
            }

            <p class="t-9@r color-cloud mt-4 mb-0">
              No nudity or unacceptable images. <br />
              Please follow the rules.
            </p>
          }
        }

        <ng-template #loadMoreBtn>
          @if (messagePhotoAlbumStore.canLoadMore()) {
            <button
              class="mh-auto mt-6"
              sbButton
              [processing]="messagePhotoAlbumStore.busy()"
              (click)="messagePhotoAlbumStore.loadMore()"
            >
              <sb-icon [name]="'big-add-thick'" />
              View More
            </button>
          }
        </ng-template>
      } @else {
        <sb-spinner class="mv-6@r mh-auto" />
      }
    </div>
  </sb-scrollbox>

  @if (messagePhotoAlbumStore.initialized() && messagePhotoAlbumStore.activeSectionName() === 'approved') {
    <div class="footer pf-6 box-shadow">
      <div class="display-flex gap-4">
        @if (messagePhotoAlbumStore.editing()) {
          @if (messagePhotoAlbumStore.photoIdsToEdit().length) {
            <button
              class="flex-grow-1"
              sbButton
              [size]="'big'"
              [stretchable]="true"
              [variant]="'fill-red'"
              (click)="messagePhotoAlbumStore.openDeleteConfirmModal()"
            >
              Delete
            </button>
          }

          <button
            class="flex-grow-1"
            sbButton
            [elevated]="true"
            [size]="'big'"
            [stretchable]="true"
            [variant]="'fill-light'"
            (click)="messagePhotoAlbumStore.stopEditing()"
          >
            Cancel
          </button>
        } @else if (messagePhotoAlbumStore.photosToSend().length) {
          <button
            class="flex-grow-1"
            sbButton
            [processing]="conversationStore.sendInProgress()"
            [size]="'big'"
            [stretchable]="true"
            [variant]="'fill-blue'"
            (click)="
              messagePhotoAlbumStore.attemptToSendMessage(
                messagePhotoAlbumStore.photosToSend(),
                messagePhotoAlbumConfig.messageForm
              )
            "
          >
            <sb-icon [name]="'send'" />
            Send
          </button>
        } @else {
          <button
            class="color-blue flex-grow-1 font-weight-500"
            sbButton
            [elevated]="true"
            [size]="'big'"
            [stretchable]="true"
            [variant]="'fill-light'"
            (click)="attachPhotoInput.click()"
          >
            <sb-icon [name]="'big-add-thick'" [size]="'6'" />
            Upload Photos
          </button>
        }
      </div>
    </div>
  }
</div>
